import { TYPES, PATH } from '../envs/core';
import Axios from 'axios';
import { placesElastic } from '../constants/api';

const a3 = 'https://www.antena3.com/noticias/elecciones/resultados/generales/';
const lasexta =
  'https://www.lasexta.com/noticias/nacional/elecciones-generales/resultados/';
const onda =
  'https://www.ondacero.es/noticias/elecciones-generales/resultados/';

const a3Val =
  'https://www.antena3.com/noticias/elecciones/resultados/valencianas/';
const lasextaVal =
  'https://www.lasexta.com/noticias/nacional/elecciones-comunidad-valenciana/resultados/';
const ondaVal =
  'https://www.ondacero.es/noticias/elecciones-valencia/resultados/';

export const getTitle = (pathType, pathYear, placeName) => {
  switch (pathType) {
    case TYPES.MUNICIPAL:
      return `ELECCIONES  MUNICIPALES DE ${placeName} ${pathYear}`;
    case TYPES.REGIONAL:
      // TODO Asumo que regional es valenciana hasta las siguientes elecciones
      //return `ELECCIONES  AUTONÓMICAS DE ${placeName} ${pathYear}`;
      return 'ELECCIONES VALENCIANAS';
    case TYPES.EUROPE:
      return `ELECCIONES  EUROPEAS ${pathYear}`;
    default:
      return `ELECCIONES GENERALES ${pathYear}`;
  }
};

const navigateByPlace = (place, host, year, type, numElection, val = false) => {
  const isAmp = window.parent.location.host.indexOf('amp') !== -1;
  var goTo = '';
  switch (host) {
    case 'antena3':
      goTo = `${val ? a3Val : a3}${year}/${type.toLowerCase()}/${numElection}/${
        place.ineId
      }${place.path}`;
      window.parent.location.href = isAmp ? goTo.replace('www.', 'amp.') : goTo;
      break;
    case 'lasexta':
      goTo = `${
        val ? lasextaVal : lasexta
      }${year}/${type.toLowerCase()}/${numElection}/${place.ineId}${
        place.path
      }`;
      window.parent.location.href = isAmp ? goTo.replace('www.', 'amp.') : goTo;
      break;
    case 'ondacero':
      goTo = `${
        val ? ondaVal : onda
      }${year}/${type.toLowerCase()}/${numElection}/${place.ineId}${
        place.path
      }`;
      window.parent.location.href = isAmp ? goTo.replace('www.', 'amp.') : goTo;
      break;
    default:
      break;
  }
};

export const refreshParent = (place, year, type, numElection, scopeChange) => {
  const host = window.location.hostname
    .replace(/www\./g, '')
    .replace(/amp\./g, '')
    .replace(/\.es/, '')
    .replace(/\.com/, '')
    .replace('localhost', 'antena3');
  if (typeof place === 'string') {
    Axios.get(`${PATH}${placesElastic}${place}`)
      .then(response => {
        return response.data;
      })
      .then(data => {
        navigateByPlace(
          data,
          host,
          year,
          type,
          numElection,
          place === 'R10' && scopeChange
        );
      });
  } else {
    navigateByPlace(
      place,
      host,
      year,
      type,
      numElection,
      place === 'R10' && scopeChange
    );
  }
};

export const getRoute = (town, community, excludes) => {
  const path = town.path.split('/');
  const locale = community ? path.pop() : path[1];
  const ineId = community ? town.ineId : town.parentId;
  const host = window.location.hostname.replace('localhost', 'antena3.com');
  if (excludes && Boolean(excludes[ineId])) {
    return excludes[ineId];
  }

  if (host.indexOf('lasexta') !== -1) {
    return `https://www.lasexta.com/noticias/nacional/elecciones-generales/resultados-de-las-elecciones-generales-2019-en-${locale}-${ineId}`;
  }
  if (host.indexOf('antena3') !== -1) {
    return `https://www.antena3.com/noticias/espana/resultado-elecciones-generales-2019-${locale}-10n-${ineId}`;
  }
  if (host.indexOf('ondacero') !== -1) {
    return `https://www.ondacero.es/noticias/elecciones-generales/resultados/2019-${locale}-10n-${ineId}`;
  }
};

export const navigateTo = (
  history,
  reload,
  internalPath,
  item,
  community,
  excludes
) => {
  if (!Boolean(parseInt(reload))) {
    history.push(internalPath);
  } else {
    const path = getRoute(item, community, excludes);
    window.parent.location.href = path;
  }
};
